import { crTrackerLockMonthUpdateApi } from '@ge/feat-analyze/services';

export const updateCRTrackerLockPeriodApi = async ({
  contractId,
  lockFlag,
  lockedBy,
  monthDate,
}) => {
  try {
    const response = await crTrackerLockMonthUpdateApi({
      contractId,
      lockFlag,
      lockedBy,
      monthDate,
    });
    return response;
  } catch (error) {
    console.error('Cr Tracker Lock Month error response : ', error);
    throw error;
  }
};
